export default __webpack_public_path__ + "static/media/SAS0240.34I-38843_-22815_0.84de19af.jpg";